/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Product_Images_InvalidInputs */

const en_error_product_images_invalid = /** @type {(inputs: Error_Product_Images_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Some files cannot be images of this product.`)
};

/**
* | output |
* | --- |
* | "Some files cannot be images of this product." |
*
* @param {Error_Product_Images_InvalidInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_product_images_invalid = /** @type {((inputs?: Error_Product_Images_InvalidInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Product_Images_InvalidInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_product_images_invalid(inputs)
});